<template>
    <a
        :href="linkUrl"
        :target="linkTarget"
        :class="{ 'active': isActive }"
        @click="navigate"
    ><slot></slot></a>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps<{
  linkUrl: string
  linkTarget?: string
  linkTitle?: string
  active?: boolean
  customHandler?:(next: () => void) => void
}>();
const store = useStore();
const router = useRouter();

const currentPage = computed(() => store.getters['page/page']);
const isActive = computed(() => props.active || (
  currentPage.value && currentPage.value.url === props.linkUrl
));

const routeParts = props.linkUrl.split(window.location.host);
const routePath = routeParts[routeParts.length - 1];

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const navigate = (e: Event) => {
  if ([undefined, null, '_self'].indexOf(props.linkTarget) >= 0) {
    e.preventDefault();

    if (typeof props.customHandler === 'function') {
      props.customHandler(() => {
        router.push(routePath).then(() => {
          toTop();
        });
      });
    } else {
      router.push(routePath).then(() => {
        toTop();
      });
    }
  }
};
</script>
